import React from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap";
import AuthWidget from "../../auth/components/AuthWidget";
import { SsoSignInView } from "@nrgpix/auth-sso";
import SustinaSsoProvider from "../sso/SustinaSsoProvider";

// Corporate SSO sign-in shows only where the site DB has been elevated to SSO (env switch).
const SSO_SIGNIN_ON = String(process.env.REACT_APP_SSO_SIGNIN || "").toLowerCase() === "true";

export default function SEC_02_01_SignInController() {
  const navigate = useNavigate();

  return (
    <main id="main" className="page-main registered-page" data-scroll-container>
      <div className="page-main-inner">
        <section className="page-section">
          <div className="page-section__body d-flex justify-content-center">
            <div style={{ width: "100%", maxWidth: "550px" }}>
              {/* Corporate SSO first: a verified company domain goes to its own IdP;
                  anyone else carries on with the password form below. */}
              {SSO_SIGNIN_ON && (<>
              <Card className="border-0 shadow-sm mb-3" style={{ borderRadius: "12px" }}>
                <Card.Body className="p-4">
                  <h2 className="mb-1 h5 fw-bold text-center">Company Sign-In (SSO)</h2>
                  <p className="small text-muted text-center mb-3">
                    Your organisation uses Microsoft, Okta or Google Workspace? Enter your work email.
                  </p>
                  <SustinaSsoProvider>
                    <SsoSignInView label="Work email" />
                  </SustinaSsoProvider>
                </Card.Body>
              </Card>
              <div className="d-flex align-items-center my-3 text-muted small">
                <hr className="flex-grow-1" />
                <span className="px-3">or sign in with your password</span>
                <hr className="flex-grow-1" />
              </div>
              </>)}
              <AuthWidget
                initialMode="SIGN_IN"
                onAuthenticated={(loginResponse) => {
                  // ✅ Redirect to post-login handoff
                  const redirect =
                    loginResponse?.redirectPath || "/auth/handoff";

                  navigate(redirect, { replace: true });
                }}
              />
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}
